import {isNullOrUndefined} from "../../../services/Validator";

export default function CoursesLayout({children}) {
    // Used in CoursesScreen to frame screen content

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}